import Immutable from 'immutable'
import moment from 'moment'
import { createSelector } from 'reselect'

const getBasket = ({ basket }) => basket

export const getOrderRecipeItems = createSelector(getBasket, (basket) =>
  basket.getIn(['orderDetails', 'recipeItems'], Immutable.List([])),
)

export const getOrderNumPortion = createSelector(getBasket, (basket) =>
  basket.getIn(['orderDetails', 'box', 'numPortions'], 0),
)

export const getOrderWhenStartDate = createSelector(getBasket, (basket) =>
  basket.getIn(['orderDetails', 'period', 'whenStart'], ''),
)

export const getOrderWhenStartDateFormatted = createSelector(
  getOrderWhenStartDate,
  (orderWhenStartDate) => moment(orderWhenStartDate).format('YYYY/MM/DD'),
)

export const getOrderRecipes = createSelector(
  getOrderRecipeItems,
  getOrderNumPortion,
  (recipeItems, orderNumPortion) => {
    let recipeItemsWithQuantity = Immutable.Map({})

    recipeItems.forEach((recipe) => {
      const recipeId = recipe.get('itemableId')
      const recipeQuantity = parseInt(recipe.get('quantity') / orderNumPortion, 10)

      recipeItemsWithQuantity = recipeItemsWithQuantity.set(recipeId, recipeQuantity)
    })

    return recipeItemsWithQuantity
  },
)

export const getOrderDeliveryDate = createSelector(getBasket, (basket) =>
  basket.getIn(['orderDetails', 'deliveryDate'], ''),
)

export const getOrderNumRecipes = createSelector(getBasket, (basket) =>
  parseInt(basket.getIn(['orderDetails', 'box', 'numRecipes'], 0), 10),
)

// Suggested delivery date for the next one-off box: the just-placed order's
// delivery date offset by the number of recipes plus one day. Shared by the
// confirmation banner's discount lookup and its reorder tap target so the
// discount shown always matches the order the banner opens.
export const getNextBoxPreferredDeliveryDate = createSelector(
  getOrderDeliveryDate,
  getOrderNumRecipes,
  (deliveryDate, numRecipes) =>
    deliveryDate
      ? moment(deliveryDate)
          .add(numRecipes + 1, 'days')
          .format('YYYY-MM-DD')
      : '',
)
